// Column definitions for analytics and channel tables
export const PLATFORM_COLUMNS = [
  {
    id: "platform",
    label: "Platform",
    sortable: true,
  },
  {
    id: "total_apps",
    label: "Total Apps",
    sortable: true,
  },
  {
    id: "red_channel",
    label: "Red Channel",
    sortable: true,
  },
  {
    id: "green_channel",
    label: "Green Channel",
    sortable: true,
  },
  {
    id: "red_percentage",
    label: "Red %",
    sortable: true,
  },
];

export const PORTFOLIO_COLUMNS = [
  {
    id: "portfolio",
    label: "Portfolio",
    sortable: true,
  },
  {
    id: "total_apps",
    label: "Total Apps",
    sortable: true,
  },
  {
    id: "red_channel",
    label: "Red Channel",
    sortable: true,
  },
  {
    id: "green_channel",
    label: "Green Channel",
    sortable: true,
  },
  {
    id: "red_percentage",
    label: "Red %",
    sortable: true,
  },
];

export const getChannelTableColumns = (activeChannelTab) => {
  const baseColumns = [
    { id: "edit_action", label: "Actions", sortable: false },
    { id: "app_id", label: "App ID", sortable: true },
    { id: "app_name", label: "App Name", sortable: true },
    { id: "platform", label: "Platform", sortable: true },
    { id: "portfolio", label: "Portfolio", sortable: true },
    { id: "status", label: "Status", sortable: true },
    { id: "trigger_type", label: "Trigger", sortable: true },
    { id: "incident", label: "Incident", sortable: true },
    { id: "priority", label: "Priority", sortable: true },
    { id: "incident_dates", label: "Incident Date", sortable: true },
    { id: "added_to_red_channel", label: "Added to Red Channel", sortable: true },
    { id: "first_review", label: "First Review", sortable: true },
    { id: "final_review", label: "Final Review", sortable: true },
    { id: "application_representative", label: "App Representative", sortable: true },
    { id: "deployment_type", label: "Deployment Type", sortable: true },
    { id: "comments", label: "Comments", sortable: true },
  ];

  if (activeChannelTab === "Moved to Green Channel" || activeChannelTab === "All") {
    baseColumns.splice(10, 0, {
      id: "moved_to_green_channel_on",
      label: "Moved to Green Channel",
      sortable: true,
    });
  }

  return baseColumns;
};

export const CHANNEL_TAB_LABELS = ["Red Channel", "Moved to Green Channel", "All"];

export const RECORDS_PER_PAGE = 100;

export const TRIGGER_OPTIONS = [
  { value: "Major Incident", label: "Major Incident" },
  { value: "SLO Breach", label: "SLO Breach" },
  { value: "Search & Create a tag", label: "Search & Create a tag" },
];

export const STATUS_OPTIONS = [
  { value: "Red", label: "Red" },
  { value: "Green", label: "Green" },
];
